export const GET_MY_LESSONS_REQUEST = 'GET_MY_LESSONS_REQUEST';
export const GET_MY_LESSONS_SUCCESS = 'GET_MY_LESSONS_SUCCESS';
export const GET_MY_LESSONS_FAILURE = 'GET_MY_LESSONS_FAILURE';
